import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useApplicationConfigQuery } from '../../../../api/queries/use-application-config-query';

export const useDiscordButton = () => {
  const { t } = useTranslation('hubCommon');
  const { data: appConfig } = useApplicationConfigQuery();

  // Backend already calculates showDiscordLink based on user's purchases
  // For TTP: always true
  // For The5ers: true only if user has completed purchases
  const isEnabled = useMemo(() => {
    if (!appConfig?.discordLink) {
      return false;
    }
    return appConfig.showDiscordLink ?? false;
  }, [appConfig?.discordLink, appConfig?.showDiscordLink]);

  const discordUrl = appConfig?.discordLink || '';

  const tooltipMessage = isEnabled ? undefined : t('discordPurchaseRequired');

  const ariaLabel = isEnabled
    ? t('discordAriaJoinCommunity')
    : t('discordAriaPurchaseRequired');

  const handleClick = () => {
    if (isEnabled && discordUrl) {
      window.open(discordUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return {
    isEnabled,
    tooltipMessage,
    ariaLabel,
    handleClick,
  };
};
